/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Басты',
	homePageTabsLabel: 'Негізгі бет мазмұны',
	myContent: 'Mенің мазмұным',
	teamContent: 'Топтық мазмұн',
	folder: 'Қалта',
	files: 'Файлдар',
	actionMenu: 'Әрекет мәзірі',
	myFolder: 'Жеке қалталарым',

	emptyFolderNoContent: 'Мазмұн жоқ',

	//EmptyStates
	emptyRecentTitle: 'Жақын арада ешбір мазмұнды көрмедіңіз.',
	emptyStateTitle: 'Деректерді қосудан бастаңыз',
	emptyStateBody: 'Жоғарыдағы деректерді жүктеу түймесін басыңыз немесе деректерді жүктеу үшін сүйреп апарыңыз.',
	emptySearchResultTitle: 'Хм, сіздің іздеуіңіз нәтиже берген жоқ.',
	emptyPortalTitle: 'Порталдар жоқ',
	emptyPortalBody: 'Қазіргі уақытта сізде ешқандай портал жоқ.',
	emptyWsProjectTitle: 'Watson Studio бағдарламасында notebook құрудан бастаңыз.',
	emptyWsProjectBody: 'Cognos Analytics бағдарламасына оралғанда, сіздің notebook осында пайда болады.',
	emptyFilteredResultTitle: 'Хм, қолданылған сүзгілер нәтиже бермеді.',
	emptyDialogViewTitle: 'Элементтер жоқ',
	removeFromRecents: 'Соңғысынан алып тастау',

	// Welcome Banner
	welcomeBannerGreeting: 'Сәлем. Cognos Analytics with Watson қызметіне қош келдіңіз.',
	welcomeBannerDescription: 'Cognos Analytics with Watson жасанды интеллект негізінде өзіне-өзі қызмет көрсету талдауы көмегімен пайдаланушылардың мүмкіндіктерін арттырады. Деректердің автоматты түрде дайындалуы, деректердің табылуы және визуализациялары сенімдірек шешімдерді қабылдауға қалай көмектесетінін көріңіз.',
	welcomeBannerDescription_trialUser: 'Біздің кіріспе бейнемізді, өнімге шолу және Жұмысқа кірісу қойындысын көру арқылы бірден бастауға болады.',
	takeTourButtonLabel: 'Өнім турына барыңыз',
	watchVideoButtonLabel: 'Бейнені қараңыз',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Үй парағынан құттықтау баннерін өшіргіңіз келетініне сенімдісіз бе? Мұны кез келген уақытта Профиль және параметрлер > Параметрлер > Жалпы бөлімінен қосуға болады. ',
	hideWelcomeBannerTitle: 'Қош келдіңіз баннерін өшіріңіз',
	ok: 'OK',
	cancel: 'Болдырмау',
	warn: 'Ескерту',
	//howto video dialog
	modal_how_title: 'Cognos Analytics шолуын қараңыз',
	modal_overview_title: 'Cognos Analytics шолуын қараңыз',
	modal_how_play: 'Бейнені ойнату',
	modal_how_video_title_overview: 'Жалпы шолу',
	modal_how_video_title_getStarted: '11.2-де жұмысқа кірісу',
	modal_how_video_title_newUI: 'Жаңа Cognos тәжірибесіне қош келдіңіз',
	modal_how_video_title_dataModule: 'Деректер модульдеріне шолу',
	modal_how_video_title_explore: 'Деректерді зерттеуге шолу',
	modal_how_video_title_dashboard: 'Интерактивті бақылау тақталарына шолу',
	modal_how_video_title_reporting: 'Есеп беруге шолу',
	modal_how_video_title_mobile: 'Cognos күші сіздің алақаныңызда',

	// Toolbar
	search: 'Іздеу',
	addFolder: 'Қалтаны қосу',
	addLink: 'Сілтеме қосу',
	filter: 'Сүзгі',
	sort: 'Сұрыптау',
	settings: 'Параметрлер',
	tilesView: 'Тақтайша көрінісі',
	listView: 'Тізім көрінісі',
	columnView: 'Баған көрінісі',
	backToSearch: 'Іздеу нәтижелеріне оралу',

	// Toolbar Actions
	sortBy: 'Сұрыптау әдісі',
	sortOrder: 'Реттеу',
	name: 'Аты',
	modifiedTime: 'Өзгертілген',
	type: 'Түрі',
	ascending: 'Артуы бойынша',
	descending: 'Кемуі бойынша',
	resetSort: 'Сұрыптауды бастапқы мәніне қайтару',

	filterType: 'Түрі',
	filterModificationTime: 'Өзгертілген',
	all: 'Барлық',
	today: 'Бүгін',
	yesterday: 'Кеше',
	pastWeek: 'Өткен апта',
	pastMonth: 'Өткен ай',
	resetFilters: 'Сүзгілерді қалпына келтіру',
	resultLimit: 'Нәтиже шегі',

	filterSearchPlaceHolder: 'Кілт сөздер бойынша сүзгілеңіз',

	resetFilterTag: 'Сүзгілерді қалпына келтіру үшін X батырмасын басыңыз.',
	filterTagToolTip: 'Қолданылған сүзгілер: %{appliedFilters}.',

	folderName: 'Қалта атауы',
	addAFolder: 'Қалтаны қосу',
	add: 'Қосу',
	error: 'Қате',
	newFolderDefaultName: 'Жаңа қалта',
	toastCreateNewFolder: '%{nameOfFolder} қалтасы %{tabName}-да жасалған.',
	folderAdded: 'Қалта қосылды',
	refresh: 'Жаңарту',
	openFolder: 'Қалтаны ашу',

	addAUrl: 'URL мекен-жайын қосу',
	linkName: 'URL мекен-жайын атауы',
	linkNamePlaceholder: 'URL мекен-жайын қосу',
	linkDescription: 'Сипаттама (таңдамалы)',
	linkDescriptionPlaceholder: 'Сипаттама қосыңыз',
	linkUri: 'URL мекен-жайы',
	linkUriPlaceholder: 'Қолайлы доменмен URL мекен-жайын қосыңыз',
	acceptableDomains: 'Рұқсат етілген домендер',
	viewAcceptableDomains: 'Рұқсат етілген домендерді көрсетіңіз',
	mandatoryField: 'Міндетті өріс',
	linkAdded: 'URL мекен-жайы қосылды',
	toastCreateNewLink: '%{nameOfLink} элементі %{tabName}-ге қосылды.',
	noEntries: 'Қолайлы домендер тізімінде жазбалар жоқ. Әкімшіңізге хабарласыңыз.',
	unacceptableDomain: 'URL мекен-жайыңыз жарамсыз доменді пайдаланады. Пайдалануға болатын домендер тізімін көру үшін \'Қолайлы домендерді көру\' түймесін басыңыз.',

	compact: 'Ықшам',
	short: 'Қысқа',
	default: 'Әдепкі',
	rowSize: 'Жол өлшемі',

	// GroupyByTypes
	folders: 'Қалталар',
	reports: 'Есептер',
	dashboards: 'Бақылау тақталары',
	data: 'Деректер',
	packages: 'Бумалар',
	explorations: 'Барлаулар',
	stories: 'Мақалалар',
	notebooks: 'Жазу кітаптар',
	others: 'Басқа',

	// Error Messages
	itemsOverLimit: '"%{itemName}" көрсетілген атау ең жоғары (20) шегінен асып кетті. Жалғастыру үшін басқа атауды көрсетіңіз.',
	errorMessageLengthFolderName: '255 таңбадан аспайтын қалта атауын енгізіңіз.',
	errorMessageLengthLinkName: '255 таңбадан аспайтын сілтеме атауын енгізіңіз.',
	toastLaunchPerspectiveError: '%{objectType} нысанын аша алмады.',
	errorNoAccessTitle: 'Хм, бұл мазмұнға кіруге рұқсатыңыз жоқ сияқты',
	errorNoAccessBody: 'Әкімшіңізге хабарласыңыз немесе келесі сілтемені қараңыз:',
	errorEnableExternalContent: 'Сыртқы мазмұнды қосу',

	//TableHeader
	lastAccessed: 'Соңғы рет қол жеткізілді',
	location: 'Орны',
	tenant: 'Қатысушы',

	// GetStartedTab
	getStartedLabel: 'IBM Cognos Analytics бағдарламасында жұмыс істеңіз',
	learningHowToLabel: 'Оқу ресурстары',
	learningHowToDescription: 'Білімді кеңейтіп, қауымдастықпен байланыс орнату, құжаттарды оқу және бейнелерді көру арқылы көмек алыңыз.',
	learningHowToActionLabel: 'Оқу аумағын іске қосыңыз',
	howToVideosLabel: 'Тәжірибелік ұсыныстары бар бейнелер',
	howToVideosDescription: 'IBM Cognos Analytics-ті қалай пайдалану керектігін біліп, деректеріңіз туралы түсінік ала бастаңыз.',
	howToVideosActionLabel: 'Бейнелерді қараңыз',
	acceleratorCatalogLabel: 'Accelerator каталогы',
	acceleratorCatalogDescription: 'Өсіп келе жатқан өнеркәсіптік каталогты, ең жақсы тәжірибелік нұсқаулықтарды, жеке көрнекіліктерді және басқаларын шолыңыз.',
	acceleratorCatalogActionLabel: 'Каталогты шолу',
	sampleSectionTitle: 'Үлгілер',
	sampleSectionDescription: 'Cognos Analytics ұсынатын барлық нәрселерді көрсететін мысалдармен тәжірибе жасаңыз.',
	// Samples Section
	createDashboardSampleTitle: 'Бірінші бақылау тақтасын қалай жасауға болады',
	createDashboardSampleDescription: 'Талдау сапарыңызды Cognos Dashboards тақталарынан бастаңыз.',
	nlaSampleTitle: 'Есеп үлгісі',
	nlaSampleDescription: 'Жыл соңындағы адалдық картасы мүшелерінің белсенділігін талдайтын осы мысал арқылы Cognos Analytics Reports мүмкіндігін зерттеңіз.',
	sankeySampleTitle: 'Санкей',
	sankeySampleDescription: 'Көрнекілендіру кітапханасын Sankey Chart сияқты жеке көрнекілендірумен кеңейтіңіз.',
	viewAllSamplesActionLabel: 'Барлық үлгілерді қарау',
	byFeatureTitle: 'Мүмкіндігі бойынша',
	byFeatureDescription: 'Негізгі функционалдылық, теңшелетін басқару элементтері, кеңейтімдер, notebooks бағдарламалары және салыстырмалы күндер сияқты ерекшеліктер бойынша үлгілерді шолу.',
	byIndustryTitle: 'Саласы бойынша',
	byIndustryDescription: 'Автокөлік, банк қызметі және басқалары сияқты салалар бойынша үлгілерді шолу.',
	// SamplesTab
	sampleTabTitle: 'Біздің алдын-ала жасалған үлгілермен шабыттаныңыз',
	sampleTabLabel: 'Accelator Каталогына IBM, серіктестер мен клиенттердің қосымша үлгілері мен кеңейтімдері үшін кіріңіз',

	// quickLaunch
	quickLaunchLabel: 'Жылдам іске қосу',
	expand: 'Кеңейту',
	collapse: 'Тасалау',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Жасағыңыз келетін нәрсені таңдаудан бастаңыз.',

	// contentPageView
	contentPageTitleLabel: 'Мазмұн',
	uploadFile: 'Деректерді жүктеп салу',
	new: 'Жаңа',
	create: 'Жасау',
	more: 'Қосымша',

	// open dialog
	selectDataSourcesToAdd: 'Қосылатын деректер көздерін таңдаңыз.',
	openDialogDefaultTitle: 'Ашу',

	// save dialog
	save: 'Сақтау',
	saveAs: 'Басқаша сақтау',
	saving: 'Сақтауда...',
	selectedDestination: 'Таңдалған бағыт: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' басқа түрімен бұрыннан бар. Басқа ат таңдаңыз.',
	confirmOverwriteTitle: 'Бұрыннан бар деректі алмастыруды құптау',
	confirmOverwriteMsg: '\'%{nameOfFile}\' файлы бұрыннан бар. Бұл деректерді файл ішінде қамтылған деректер орнын ауыстыруды қалайсыз ба?',

	// copy move dialog
	copy: 'Көшіру',
	move: 'Жылжыту',
	copyOrMove: 'Көшіру немесе жылжыту: ',
	copyOnly: 'Көшіру ',
	createShortcut: 'Сілтеме жасау',
	createShortcutDialogTitle: 'Сілтеме жасау: ',

	// External asset types
	wsProject: 'Watson Studio жобасы',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Бума',
	dataModule: 'Деректер модулі',
	exploration: 'Зерттеу',
	mode: 'Режим',
	live: 'Тікелей',
	snapshot: 'Сурет',
	noSnapshotsFound: 'Ешқандай сурет табылмады',
	uploadedFile: 'Жүктелген файл',
	fileUpload: 'Деректерді жүктеп салу',
	dataSetEx: 'Деректер орнатуы',
	externalRepository: 'Сыртқы репозиторий',
	queryMode: 'Сұрау күйі',
	queryModeCompatible: 'Сыйысымды',
	queryModeDynamic: 'Динамикалық',
	report: 'Есеп',
	activeReport: 'Белсенді есеп',
	query: 'Сұрау',
	analysis: 'Талдау',
	dashboard: 'Бақылау тақтасы',
	dashboardTemplate: 'Бақылау тақтасының үлгісі',
	jupyterNotebook: 'Блокнот',
	wsNotebook: 'Watson Studio notebook',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Мәтіндік бөлік',
	workspace: 'Жұмыс кеңістігі',
	pagelet: 'Бет',
	content: 'Мазмұн',
	directory: 'Атау кеңістіктері',
	dataSet: 'Деректер орнатуы',
	powerPlayCube: 'PowerPlay текшесі',
	powerPlayReport: 'PowerPlay есебі',
	powerPlay8Report: 'PowerPlay есебі',
	setPowerPlay8ReportOptions: 'PowerPlay есеп параметрлерін орнатыңыз',
	powerPlay8ReportView: 'PowerPlay есеп көрінісі',
	reportTemplate: 'Есеп үлгісі',
	packageConfigurations: 'Бума теңшелімі',
	agent: 'Агент',
	agentDefinition: 'Агент анықтамасы',
	agentDefinitionView: 'Агент көрінісі',
	dataMovementTask: 'Дерек тасымалының тапсырмасы',
	dataMovementTaskAlias: 'Дерек тасымалының тапсырмасының бүркеніш аты',
	document: 'Құжат',
	DocumentRetention: 'ҚҰжат сипаттары',
	jobDefinition: 'Жұмыс анықтамасы',
	job: 'Жұмыс',
	jobs: 'Жұмыстар',
	metricsDataSourceETLTask: 'Метрикалар деректер көзінің ETL тапсырмасы',
	metricsExportTask: 'Метрикаларды экспорттау тапсырмасы',
	metricsFileImportTask: 'Метрикалар файлын импорттау тапсырмасы',
	metricsMaintenanceTask: 'Метрикаларды сақтау тапсырмасы',
	planningTask: 'Жоспарлау тапсырмасы',
	shortcut: 'Таңбаша',
	shortcuts: 'Таңбашалар',
	URL: 'URL мекен-жайы',
	launchable: 'Іске қосылатын',
	dataSetFolder: 'Деректер жиынтыңының қалтасы',
	ViewAccessibleLabel: '%{label} қарау',
	overrideReportOptions: 'Әдепкі есеп опцияларін қайта жазу',
	formats: 'Пішімдер',
	saveReport: 'Есепті сақтау',
	reportView: 'Есеп көрінісі',
	reportviews: 'Есеп көріністері',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel деректері',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Рөл',
	namespace: 'Аттар кеңістігі',
	namespaceFolder: 'Аттар кеңістігі қалтасы',
	adminFolder: 'Әкімші қалтасы',
	//Details
	details: 'Мәліметтер',
	open: 'Ашу',
	created: 'Жасалған',
	modified: 'Өзгертілген',
	owner: 'Иесі',
	dataSource: 'Деректер көзі',
	share: 'Ортақ пайдалану',
	addToFavorites: 'Таңдаулыларға қосу',
	properties: 'Сипаттар',
	detailsEmptyStateBody: 'Мәліметтерін көру үшін элементті таңдаңыз',
	editNameAndDescription: 'Аты мен сипаттамасын өңдеу',
	none: 'Ешбір',
	setPdfOptions: 'PDF параметрлерін орнату',
	runOptions: 'Іске қосу опциялары',

	//rename dialog
	nameInvalid: 'Атау жарамсыз',
	namePlaceholder: 'Ат енгізу',
	description: 'Сипаттама',
	descriptionInvalid: 'Сипаттама 350 таңбадан аспауы керек.',
	descriptionPlaceholder: 'Сипаттаманы енгізіңіз',
	errorMessageApostropheError: 'Екі \' және " таңбаларын қамтымайтын файл атауын енгізіңіз',
	renameCollisionError: '%{name} бұрыннан бар. Басқа атты көріңіз.',
	unknownRenameError: 'Элементтің атауы өзгертілмеді. Қосымша көмек алу үшін әкімшіңізге хабарласыңыз.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Көрсетілген қалтаны ашу мүмкін емес.',

	//Upload
	uploadToFolder: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}-ға жүктеңіз",
	uploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>-ға жүктеп %{launchAction} іске қосыңыз",
	quickUpload: "Жылдам жүктеу",
	quickUploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>-ға жүктеу үшін файлдарды сүйреп апарыңыз және келесі бос орындардың бірінде ашыңыз.",
	unsupportedFilesSingle: "%{files} жүктелмеді, себебі ол жылдам іске қосу үшін жарамсыз.",
	unsupportedFilesMultiple: "Файлдар кері жүктелмеді, себебі таңдалған барлық файлдар жылдам іске қосуын пайдалану үшін жарамды болуы керек.",
	unsupportedFilesSingleInvalid: "%{files} жарамсыз.",
	unsupportedFilesMultipleInvalid: "%{files} жарамсыз.",
	supportedFileTypes: "Тек келесі файл түрлеріне рұқсат етіледі: %{extensions}.",
	uploadDragAndDrop: "Апарып тастау",
	uploadDragAndDropMessage: "Файлды <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>-ға жүктеу үшін оны сүйреп апарыңыз",

	// searchBar
	searchWasSaved: 'Іздеу критерийлері \'%{searchTerm}\' сақталды.',
	searchWasntSaved: 'Іздеу критерийлері \'%{searchTerm}\' сақталмады.',
	searchSuggestions: 'Ұсыныстар',
	savedSearch: 'Сақталған іздеулер',
	searchWasDeleted: 'Іздеу критерийлері \'%{searchTerm}\' жойылды.',
	searchWasntDeleted: '\'%{searchTerm}\' іздеу критерийлері жойылған жоқ.',
	savedBarTitle: 'Cognos Analytics іздеу',
	searchContentPageTitle: 'Іздеу',
	searchContentPageTitleLabel: '\'%{searchTerm}\' нәтижелерін көрсету',
	showingSearchRsult: '%{resultCount} элементтерін көрсету',
	saveSearch: 'Іздеуді сақтау',
	saveTenSearches: '10 іздеуді сақтай аласыз.',
	deleteASearch: 'Өзгесін сақтау үшін біреуін жойыңыз.',
	close: 'Жабу',
	allContent: 'Барлық мазмұн',
	searchResultIn: 'Іздеу нәтижелері: ',
	//recent view
	recents: 'Соңғы',
	noAccessRecent: 'Кіруге болмайды',
	noAccessRecentMsg: 'Бұл активке рұқсатыңыз жоқ. Ол ажыратылған немесе жойылған немесе сіздің рұқсаттарыңыз азайған болуы мүмкін. Активтің жай-күйін күтілетін бастапқы орында тұрған жерінде тексеріңіз. Соңғы элементтерден активті OK түймешігін басу арқылы жоюға болады.',
	noAccessMsg: 'Бұл активке рұқсатыңыз жоқ. Ол ажыратылған немесе жойылған немесе сіздің рұқсаттарыңыз азайған болуы мүмкін.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} элемент таңдалды',
	itemSelected: '%{nameOfSelection} элемент таңдалды',

	//properties
	general: 'Жалпы',
	schedule: 'Кесте',
	permission: 'Рұқсаттары',
	capabilities: 'Мүмкіндіктер',
	propertiesTabsLabel: 'Сипаттар мазмұны',
	searchPath: 'Іздеу жолы',
	id: 'ID',
	language: 'Тіл',
	setLanguage: 'Тілді орнату',
	entryOptions: 'Кіру опциялары',
	setPackage: 'Буманы немесе модульді орнату',
	sourcePackage: 'Бастапқы бума немесе деректер модулі',
	associatedSourceAgent: 'Бастапқы пакет',
	setAssociatedSourceAgent: 'Пакетті орнату',
	sourceAgent: 'Бастапқы агент',
	setSourceAgent: 'Бастапқы агентті орнату',
	setCapabilities: 'Мүмкіндіктерді орнату',
	disableEntry: 'Мына жазбаны өшіру',
	hideEntry: 'Мына жазбаны жасыру',
	permissions: 'Рұқсаттар',
	promptForValues: 'Мәндер үшін шақыру',
	yes: 'Иә',
	no: 'Жоқ',
	setValues: 'Мәндерді орнату',
	moreOptions: 'Қосымша Опциялар',
	reportFormat: 'Есептің пішімі',
	enableAccessibilitySupport: 'Арнайы мүмкіндіктер қолдауын қосу',
	displayOfRunHistory: 'Іске қосу тарихын көрсету',
	occurrences: 'Оқиғалар',
	days: 'Күн(дер)',
	months: 'Ай(лар)',
	displayOfReportOutputVersions: 'Есеп шығару нұсқасын көрсету',
	defaultDisplayOfPortalAction: 'Әдепкі портал әрекеті',
	viewMostRecentReport: 'Ең соңғы есепті қарау',
	runTheReport: 'Есепті іске қосу',
	openWithReportStudio: 'Report Studio бағдарламасымен ашу',
	rowsPerPageInHtmlReports: 'HTML есептеріндегі әр бетке арналған жолдар',
	enableSelectionBasedInteractivity: 'Таңдауға негізделген өзара әрекетті қосу',
	enableAlertsAboutNewVersions: 'Жаңа нұсақлар туралы ескертулерді қосу',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Сақталған шығару нұсқаларында пайдаланушының кеңейтілген мүмкіндіктерін қосу',
	enableCommentsInSavedOutputVersions: 'Сақталған шығыс нұсқаларындағы пікірлерді қосыңыз',
	run: 'Іске қосу',
	runWithUsersCredentials: 'Пайдаланушының тіркелгі деректерімен',
	runWithOwnerCapabilities: 'Иесінің мүмкіндігімен',
	runAsOwner: 'As %{ownerName}',
	actionLabelOn: 'Қосылу',
	actionLabelOff: 'шығу',
	openReport: 'Өңдеу',
	openAnalysis: 'Analysis Studio бағдарламасымен ашу',
	openQuery: 'Query Studio бағдарламасымен ашу',
	openPowerPlay8Report: 'PowerPlay Studio бағдарламасымен ашу',
	openInteractiveReport: 'Өңдеу',
	read: 'Оқу',
	write: 'Жазу',
	execute: 'Орындау',
	setPolicy: 'Саясат орнату',
	full: 'Толық',
	traverse: 'Кесіп өту',
	grant: 'Беру',
	deny: 'Тыйым салу',
	permissionCustom: 'Тұтынушы',
	permissionDetailsColumnAccess: 'Қатынас',
	permissionDetailsColumnPermission: 'Рұқсат',
	permissionDetailsColumnAction: 'Әрекет',
	permissionSetAccess: 'Қатынас орнату',
	permissionRead: 'Оқу',
	permissionRun: 'Іске қосу',
	permissionWrite: 'Жазу',
	permissionFull: 'Толық',
	unavailable: 'Қолжетімді емес',
	unkownSource: 'Белгісіз, мәліметтер үшін есепті ашыңыз',
	tenantSettings: 'Жалға алушы параметрлері',
	tenantSet: 'Жалға алушы жаңартылды',
	tenantSetError: 'Жалға алушыны орнату қатесі',
	tenantClear: 'Жалға алушы тазартылды',
	tenantClearError: 'Жалға алушыны тазалау қатесі',
	shortcutTo: 'таңбашасы',
	sourceReport: 'Бастапқы есеп',
	setSourceReport: 'Бастапқы есепті орнату',
	setSourceLocation: '%{элемент_аты} бастапқы орнын орнату',
	linkPackageOrModule: '%{элемент_аты} бумамен немесе деректер модулімен байланыстыру',
	linkPackage: '%{элемент_аты} бумамен байланыстыру',
	externalRepositories: 'Сыртқы репозиторийлер',
	sizeByte: '%{мән} байт',
	sizeKiloByte: '%{мән} Кбайт',
	sizeMegaByte: '%{мән} Мбайт',
	sizeGigaByte: '%{мән} Гбайт',
	sizeTeraByte: '%{мән} Тбайт',
	sizePetaByte: '%{мән} Пбайт',
	refreshedDatetime: 'Жаңартылған уақыт',
	size: 'Өлшем',
	tenantsWarningMessage: 'Жазба клиентін өзгерту бала жазбаларының клиентін де өзгертеді.',
	confirmClearTenantText: 'Мәнді «Ешқандай» етіп тазалау басқа қатысушылардың мазмұнға қатынасуына мүмкіндік береді. Жазбаны жалпыға ортақ ету үшін «OK» түймесін немесе ағымдағы клиентті сақтау үшін «Бас тарту» түймесін басыңыз.',
	confirmClearTenant: 'Клиентті жоюды растау',
	currentValues: 'Ағымдағы мәндер',
	emptyPromptValues: 'Қазір ешбір мән жоқ',
	editValues: 'Мәндерді өңдеу',
	clear: 'Тазалау',
	source: 'Дереккөз',
	dataRefreshed: 'Деректер жаңартылған',
	//PDF options
	pdfOptions: 'PDF опцияларі',
	set: 'Орнату',
	portrait: 'Кітаптық',
	landscape: 'Альбомдық',
	letter: 'Хат',
	legal: 'Құқықтық',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Бағдар',
	pageDefination: 'Қағаз өлшемі',
	openPasswordRequired: 'Есепті ашу үшін құпия сөзді талап ету',
	accessPasswordRequired: 'Есепке қатынасу үшін құпия сөзді талап ету',
	emptyPassword: 'Құпия сөз бос болмауы қажет',
	password: 'Құпия сөз',
	enterPassword: 'Құпия сөзді енгізіңіз',
	confirmPassword: 'Құпия сөзді растаңыз',
	passwordMatchError: 'Құпия сөздер сәйкес келмейді',
	gateway: 'Шлюз',
	pageLayout: 'Бет макеті',
	pageStyle: 'Мәнер',
	setUrl: 'URL мекенжайын орнату',
	numberRows: 'Қатарлар саны',
	numberColumns: 'Бағандар саны',
	timeToRefresh: 'Жаңарту уақыты',
	lastRefreshedBy: 'Жаңартқан',
	unknown: 'Белгісіз',
	unknownUpdateError: 'Элементті жаңарту мүмкін болмады. Қосымша көмек алу үшін әкімшіңізбен байланысыңыз.',
	editQuery: 'Сұрауды өңдеу',
	greaterOrEqual: '%{upperboundValue} -дан үлкен немесе оған тең',
	lessOrEqual: '%{lowerboundValue} -дан аз немесе оған тең'
});
